import styled from '@emotion/styled'
import { calcRem } from 'component-library/__styling/style-functions'

export const StyledLogo = styled('img')({
    width: calcRem(50),
    verticalAlign: 'bottom',
    alignSelf: 'flex-end',
})
